// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_h0-0";
export var actionModalContentContainer = "_h0-1";
export var createTagButton = "_h0-2";
export var footerContainer = "_h0-7";
export var fullWidthDivider = "_h0-3";
export var hasCreateTagButton = "_h0-4";
export var noCreateTagButton = "_h0-5";
export var tagsContainer = "_h0-6";
export var tagsModalContentContainer = "_h0-8";